// export const BASE_URL = 'http://localhost:8080'
export const BASE_URL = 'https://paths-mentorship.herokuapp.com'
